/**
 * 本を引く入口（2026-10-12・本人「ガチャを選ぶ画面を消す。後から2つのガチャをまた開くとき楽できるように」）。
 * GACHA_SELECT_ENABLED が false のあいだは、ガチャを選ぶ画面（/gacha/select）を使わず、本を引く入口は小説ガチャ（/gacha）へ直接行く。
 * 精霊ガチャをまた開くときは true にするだけでよい: 下のナビ・ホームの部品・司書の吹き出しの「本を引く」が選ぶ画面へ戻り、
 * 選ぶ画面（小説ガチャと精霊ガチャの2つのボタン）が開くようになり、精霊のいないときの「精霊ガチャへ」も出る。
 * 読者アプリと管理UIの両方から読めるよう、import は書かない
 */
export const GACHA_SELECT_ENABLED = false;

/** 本を引く入口の画面 */
export const GACHA_ENTRY_PATH = GACHA_SELECT_ENABLED ? "/gacha/select" : "/gacha";
